import { c$ } from "@/lib/tips";

export function Rankings({ r }) {
  if (!r || !r.metrics.some((m) => m.value_cents != null)) return null;
  return (
    <div className="card-surface p-4 space-y-3" data-testid="rc-rankings">
      <div className="flex items-baseline justify-between gap-2"><div className="font-medium">Normalized ranking</div><div className="text-xs text-stone-500">{`vs ${r.peers} ${r.role || "team"}${r.peers === 1 ? "" : "s"} · fair across shift length & volume`}</div></div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">{r.metrics.map((m) => (
        <div key={m.key} className="rounded-lg bg-[#FBF9F5] p-3" data-testid={`rc-rank-${m.key}`}>
          <div className="text-[11px] uppercase tracking-wider text-stone-500">{m.label}</div>
          <div className="font-display text-xl num">{c$(m.value_cents)}</div>
          <div className="text-xs text-stone-600">{m.rank ? `#${m.rank} of ${m.of}` : "—"}{m.peer_avg_cents != null && <span className="text-stone-400">{` · avg ${c$(m.peer_avg_cents)}`}</span>}</div>
        </div>))}</div>
      {!!r.by_period.length && <div className="text-sm" data-testid="rc-by-period"><div className="text-xs uppercase tracking-wider text-stone-500 mb-1">By service period</div>
        {r.by_period.map((p) => (
          <div key={p.period} className="flex justify-between gap-2 py-1 border-b border-dashed last:border-0"><span>{`${p.period} · ${p.shifts} shift${p.shifts === 1 ? "" : "s"}`}</span>
            <span className="num">{`${c$(p.per_shift_cents)} / shift`}<span className="text-stone-400">{p.team_per_shift_cents != null ? ` (team ${c$(p.team_per_shift_cents)})` : ""}</span></span></div>))}</div>}
    </div>
  );
}
